/**
 * @generated SignedSource<<5d7dffc53d431ab6bb23045f74c43492>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateWhatToSeeInput = {
  city?: SetEntityInput | null;
  country?: SetEntityInput | null;
  description?: string | null;
  name?: string | null;
  pois?: ReadonlyArray<SetEntityInput> | null;
  poisDescription?: string | null;
  region?: SetEntityInput | null;
};
export type SetEntityInput = {
  id: string;
};
export type WhatToSeeEditMainMutation$variables = {
  id: string;
  input: UpdateWhatToSeeInput;
};
export type WhatToSeeEditMainMutation$data = {
  readonly updateWhatToSee: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "WhatToSeeEditMain_whatToSee">;
  };
};
export type WhatToSeeEditMainMutation = {
  response: WhatToSeeEditMainMutation$data;
  variables: WhatToSeeEditMainMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WhatToSeeEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatToSee",
        "kind": "LinkedField",
        "name": "updateWhatToSee",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WhatToSeeEditMain_whatToSee"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WhatToSeeEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatToSee",
        "kind": "LinkedField",
        "name": "updateWhatToSee",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "poisDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Poi",
            "kind": "LinkedField",
            "name": "pois",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "094593c1be13bb4a8291e704613e1a22",
    "id": null,
    "metadata": {},
    "name": "WhatToSeeEditMainMutation",
    "operationKind": "mutation",
    "text": "mutation WhatToSeeEditMainMutation(\n  $id: ID!\n  $input: UpdateWhatToSeeInput!\n) {\n  updateWhatToSee(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...WhatToSeeEditMain_whatToSee\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment WhatToSeeEditMain_whatToSee on WhatToSee {\n  id\n  name\n  description\n  poisDescription\n  country {\n    id\n    name\n  }\n  region {\n    id\n    name\n  }\n  city {\n    id\n    name\n  }\n  pois {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b4ff9333540ba7c7761ca17e9d8360c";

export default node;
